import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ role, children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-mono text-sm text-[color:var(--dt6-muted)] tracking-[0.2em]">
          INITIALIZING...
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  }
  if (role) {
    const allowed = Array.isArray(role) ? role : [role];
    if (!allowed.includes(user.role)) {
      const dest =
        user.role === "admin" ? "/admin" :
        user.role === "partner" ? "/partner" :
        user.role === "buyer" ? "/buyer" :
        "/client";
      return <Navigate to={dest} replace />;
    }
  }
  return children;
}
